module.exports = __webpack_public_path__ + "media/dashboard/assets/tutorials/configuracao_sistema-2287488bd0ea9dcd6dc9f8be5a7a7435.gif";